<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
      <div class="flex flex-wrap items-center justify-between mb-10">
        <div class="flex items-center">
          <h4 style="margin-left: 10px">User Group</h4>
        </div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button @click="resetForm(); showAddForm = true" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
          <vs-button
            @click="viewData"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeItem"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="showFilterForm = true"
            icon="filter_list"
          >Filter</vs-button>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usergroups"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
      <vs-prompt buttons-hidden title="Filter" :active.sync="showFilterForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="filter.code" class="mb-2 w-full" label="Group Code" />
          <vs-input v-model="filter.name" class="mb-2 w-full" label="Group Name" />
          <vs-select
              class="selectExample"
              v-model="filter.enable"
              width="100%"
              label="Enable"
          >
              <vs-select-item value="1" text="Yes"/>
              <vs-select-item value="0" text="No"/>
          </vs-select>
          <!-- <vs-input v-model="filter.created_at" class="mb-2 w-full" label="Created At" /> -->
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2" @click="filterData">Search</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form view data -->
      <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="form.code" class="mb-2 w-full" label="Group Code" :readonly="!editMode"/>
          <vs-input
            v-model="form.name"
            class="mb-2 w-full"
            label="Group Name"
            :readonly="!editMode"
          />
          <vs-select
              class="selectExample"
              v-model="form.enable"
              width="100%"
              label="Enable"
              :disabled="!editMode"
          >
              <vs-select-item value="1" text="Yes"/>
              <vs-select-item value="0" text="No"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2 mr-2" @click="editMode = true">Edit</vs-button>
            <vs-button color="primary" class="mt-2" @click="saveData" :disabled="!editMode">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form add data -->
      <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="form.code" class="mb-2 w-full" label="Group Code" />
          <vs-input v-model="form.name" class="mb-2 w-full" label="Group Name" />
          <vs-select
              class="selectExample"
              v-model="form.enable"
              width="100%"
              label="Enable"
          >
              <vs-select-item value="1" text="Yes"/>
              <vs-select-item value="0" text="No"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2" @click="addData">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      usergroups: [],
      selectedId: null,
      isLoading: false,
      editMode: false,
      filter: {
        code: "",
        name: "",
        enable: 1,
      },
      form: {
        code: "",
        name: "",
        enable: 1
        // created_at: ""
      },

      // Show forms
      showFilterForm: false,
      showViewForm: false,
      showAddForm: false,

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    resetForm() {
      this.form = {
        code: "",
        name: "",
        enable: 1
      }
    },
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this user?",
        accept: this.acceptDelete
      });
    },
    viewData() {
      this.showViewForm = true;
      this.$http
        .get("rolemanagement/usergroup/" + this.selectedId)
        .then(resp => {
          this.form.name = resp.data.name;
          this.form.code = resp.data.code;
          this.form.enable = resp.data.enable;
        })
        .catch(resp => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: resp,
            text: "Try again?",
            accept: () => {
              this.fetchData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        });
    },
    acceptDelete() {
      this.isLoading = true;
      this.$http
        .delete("rolemanagement/usergroup/" + this.selectedId + "/destroy")
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "User deleted",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected user was successfully deleted"
          });
        })
        .catch(error => {
          const message = error.response.data.message
            ? error.response.data.message
            : "Something went wrong";
          this.$vs.notify({
            title: "Error",
            text: message,
            color: "danger"
          });
        })
        .then(() => {
          this.fetchData();
        });
    },
    saveData() {
      this.$http
        .put(
          "rolemanagement/usergroup/" + this.selectedId + "/update",
          this.form
        )
        .then(resp => {
          this.currentPage = 1;
          this.fetchData();
        })
        .catch(resp => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: resp,
            text: "Try again?",
            accept: () => {
              this.fetchData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.showViewForm = false));
    },
    addData() {
      this.$http
        .post("rolemanagement/usergroup/store", this.form)
        .then(resp => {
          this.currentPage = 1;
          this.fetchData();
        })
        .catch(resp => {
          this.$vs.notify({
            color: "danger",
            title: "Error saving",
            iconPack: "feather",
            icon: "icon-x",
            text: resp
          });
        })
        .then(() => (this.showAddForm = false));
    },
    filterData() {
      this.currentPage = 1;
      this.fetchData();
      this.showFilterForm = false;
    },
    refreshData() {
      this.fetchData();
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .post("rolemanagement/usergroup?page=" + this.currentPage, this.filter)
        .then(resp => {
          this.usergroups = resp.data.data.map(item => {
            return {
              id: item.id,
              enable: item.enable == 1 ? "Yes" : "No",
              name: item.name,
              code: item.code
            };
          });

          this.totalPage = resp.data.last_page;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.currentPage = resp.data.current_page;
        })
        .catch(resp => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Something went wrong",
            text: "Try again?",
            accept: () => {
              this.fetchData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    }
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Code",
        field: "code",
        width: 150
      },
      {
        headerName: "Group Name",
        field: "name",
        width: 150
      },
      {
        headerName: "Enable",
        field: "enable",
        width: 150
      }
      // {
      //   headerName: "Created At",
      //   field: "created_at",
      //   filter: true
      // }
    ];
  }
};
</script>